import { FC } from "react";
import { formatAdaptive } from "@/utils/number";

interface TotalVolumeHeadlineProps {
	value: number;
	unitLabel: string;
	percentOfTotal: string;
	numberClassName?: string;
}

export const TotalVolumeHeadline: FC<TotalVolumeHeadlineProps> = ({
	value,
	unitLabel,
	percentOfTotal,
	numberClassName = "text-3xl",
}) => (
	<div className="text-center">
		<div className={`${numberClassName} font-bold text-primary leading-tight`}>
			{formatAdaptive(value)} <span className="text-base font-medium text-muted-foreground">{unitLabel}</span>
		</div>
		<div className="text-xs text-muted-foreground mt-0.5">{percentOfTotal}% of total flow</div>
	</div>
);
